import React from "react";
import {observer} from "mobx-react";
import {NullableGender, translateGender} from "../../../services/dot-rez-api/data-contracts/enums/gender.enum";
import {useServices} from "../../../hooks/use-services.hook";
import {FieldViewComponent} from "../field-view.component";

export const GenderValueViewComponent: React.FC<{value: NullableGender; label?: string}> = observer((props) => {
    const services = useServices();
    const label = props.label || services.language.translate('Gender');
    let value = translateGender(props.value, services.language);

    return (
        <FieldViewComponent label={label} value={value}/>
    );
});
